import {Component, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {translate} from '@jsverse/transloco';

@Component({
    selector: 'app-manage-columns',
    templateUrl: './manage-columns.component.html',
    styleUrls: ['./manage-columns.component.scss'],
    standalone: false
})
export class ManageColumnsComponent implements OnInit {

  title: string = translate('DIALOG.CONFIRMATION');
  confirmButtonText: string = translate('DIALOG.CONFIRM');
  subTitle: string;
  columns: any;
  updateColumns: any;
  columnUpdated = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public matdialogRef: MatDialogRef<ManageColumnsComponent>) {
  }

  ngOnInit(): void {
    this.title = this.data.title || this.title;
    this.subTitle = this.data.subTitle || this.subTitle;
    this.columns = JSON.parse(JSON.stringify(this.data.columns));
    this.updateColumns = this.data.columns.map(col => ({ ...col }));
    this.confirmButtonText = this.data.confirmButtonText || this.confirmButtonText;
  }

  updateValue(event, key): void {
    this.updateColumns = this.updateColumns.map(item =>
      item.key === key ? { ...item, visible: event.checked } : item);
    const updatedCol = this.updateColumns;
    const initialCol = this.columns;
    const compareColumns = (updatedCol, initialCol) => updatedCol.key === initialCol.key && updatedCol.visible === initialCol.visible;
    const onlyInLeft = (left, right, compareFunction) => 
      left.filter(leftValue => !right.some(rightValue => compareFunction(leftValue, rightValue)));
    const onlyInUpdate = onlyInLeft(updatedCol, initialCol, compareColumns);
    const onlyInInitial = onlyInLeft(initialCol, updatedCol, compareColumns);
    const result = [...onlyInUpdate, ...onlyInInitial];
    if(result?.length) {
      this.columnUpdated = true;
    } else {
      this.columnUpdated = false;
    }
  }

  update(): void {
    this.matdialogRef.close(this.updateColumns);
  }

  cancel(): void{
    this.matdialogRef.close(this.columns);
  }
}
